export const cantOpenDetail = 'cantOpenDetail';
export const selectedValidator = 'selectedValidator';